// Clients-list Quick filters — named shortcuts over the Clients list, shared by the API (list contract +
// the "Clients · …" summary on a bulk text) and the admin web app (the Quick filters menu), so a filter is
// named the same everywhere. The rules behind each one live in the API (client-quick-filters.ts).
// ---------------------------------------------------------------------------

export const CLIENT_QUICK_FILTERS = [
  'signed_up_never_came',
  'not_seen_90_days',
  'birthday_this_month',
  'came_once_not_back',
  'overdue_regulars',
] as const;
export type ClientQuickFilterId = (typeof CLIENT_QUICK_FILTERS)[number];

/** Display name per Quick filter (menu item title, selected pill, bulk-text summary chip). */
export const CLIENT_QUICK_FILTER_TITLES: Record<ClientQuickFilterId, string> = {
  signed_up_never_came: 'Signed up, never came',
  not_seen_90_days: 'Haven’t seen in 90+ days',
  birthday_this_month: 'Birthday this month',
  came_once_not_back: 'New clients who didn’t come back',
  overdue_regulars: 'Overdue regulars',
};

/**
 * Quick lists built on visit history. Hayven can't see visits on a salon's own POS, so in POS check-in mode they
 * would name weekly regulars as lapsed: the web hides them and the API refuses them (`VISIT_HISTORY_NOT_TRACKED`).
 */
export const VISIT_HISTORY_QUICK_FILTERS = ['not_seen_90_days', 'came_once_not_back', 'overdue_regulars'] as const satisfies
  readonly ClientQuickFilterId[];

export function isVisitHistoryQuickFilter(quickFilter: ClientQuickFilterId): boolean {
  return (VISIT_HISTORY_QUICK_FILTERS as readonly ClientQuickFilterId[]).includes(quickFilter);
}
